var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('message-list-common',{attrs:{"messageType":"S_UPLOAD_LOG"}})
}
var staticRenderFns = []

export { render, staticRenderFns }